export default "__VITE_ASSET__0W54W86O__ 584w";